import {Pipe, PipeTransform} from '@angular/core';
import {TtmType} from '../classes/ttmtype';
import {Ttm} from '../classes/ttm';

@Pipe({
    name: 'presentTtmTypes'
})
export class PresentTtmTypesPipe implements PipeTransform {

    transform(ttmTypes: TtmType[], ttms: Ttm[], ...args: unknown[]): TtmType[] {
        return ttmTypes.filter(tt => ttms?.filter(ttm => ttm.type_key === tt.key)?.length > 0);
    }

}
